/* eslint-disable react/no-array-index-key */
import React from "react";
import { useNavigate } from "react-router-dom";
import { IconButton, Skeleton } from "@mui/material";

import DropdownIcon from "assets/images/chevron-bottom.svg";

import "./reportedFlags.css";

const leaveYearSkeltonStyle = {
  borderRadius: "26px",
  backgroundColor: "rgb(189 192 255 / 30%)",
};

function ReportedFlags(props) {
  const navigate = useNavigate();
  const { timeOffFlags, timeOffFlagsLoading } = props;

  const handleIconClick = (flag) => {
    const queryParams = new URLSearchParams();

    if (flag?.filter) {
      Object.keys(flag.filter).forEach((key) => {
        queryParams.append(key, flag.filter[key]);
      });
    }

    const queryString = queryParams.toString();

    if (queryString) {
      navigate(`/main/admin/timeoff/new-activity?${queryString}`);
    } else {
      navigate("/main/admin/timeoff/new-activity");
    }
  };

  return (
    <div style={{ padding: "0px" }}>
      <div className="header">
        <div style={{ fontSize: "16px", lineHeight: "24px", fontFamily: "Poppins-SemiBold", letterSpacing: "0.15px" }}>
          Flags reported this week
        </div>
        <span className="notificationDot" />
      </div>
      <ul className="list" style={{ padding: "9px 16px 14px 16px", backgroundColor: "#fbfaff" }}>
        <div style={{ borderRadius: "14px", background: "#ffffff" }}>
          {timeOffFlagsLoading ? (
            <div>
              <li className="listItem" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {Array.from({ length: 4 }).map((_, index) => (
                  <Skeleton
                    key={`${index}-skeleton`}
                    variant="rectangle"
                    sx={{ ...leaveYearSkeltonStyle, borderRadius: "16px", width: "100%", height: "41px" }}
                  />
                ))}
              </li>
            </div>
          ) : (
            timeOffFlags?.map(
              (flag) =>
                flag?.name !== "New Activity this week" && (
                  <li key={flag?.name} className="listItem">
                    <div style={{ display: "flex", gap: "3px" }}>
                      <div
                        className="count"
                        id="flag-count"
                        style={{ fontFamily: "Poppins-SemiBold", fontSize: "14px", lineHeight: "20px" }}
                      >
                        {flag?.value || 0}
                      </div>
                      <div
                        className="title"
                        id="flag-name"
                        style={{ fontFamily: "Poppins-Regular", fontSize: "14px", lineHeight: "20px" }}
                      >
                        {flag?.name || "-"}
                      </div>
                    </div>
                    <div className="chevron">
                      <IconButton onClick={() => handleIconClick(flag)}>
                        <img
                          className="dropdown-icon"
                          src={DropdownIcon}
                          alt="chevron-bottom"
                          style={{ transform: "rotate(-90deg)" }}
                        />
                      </IconButton>
                    </div>
                  </li>
                )
            )
          )}
        </div>
      </ul>
    </div>
  );
}

export default ReportedFlags;
